export const pt = {
  title: 'Florestas Primárias',
  subtitle: '30 m, trópicos, UMD/GLAD',
  download_data: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  learn_more: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  content: [
    {
      label: 'Função',
      value:
        'Este conjunto de dados mapeia a extensão das florestas primárias nas regiões pantropicais mundiais em 2001.',
    },
    {
      label: 'Resolução',
      value: '30 × 30 metros',
    },
    {
      label: 'Cobertura geográfica',
      value: 'Pan-tropical',
    },
    {
      label: 'Fonte',
      value:
        'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Ongoing primary forest loss in Brazil, Democratic Republic of the Congo, and Indonesia. Environmental Research Letters, 13(7), p.074028.',
    },
    {
      label: 'Dados de conteúdo',
      value: 2001,
    },
  ],
  overview: {
    label: 'Visão geral',
    value:
      'As florestas primárias estão entre as florestas de maior biodiversidade, fornecendo uma infinidade de serviços ao ecossistema, o que as torna cruciais para monitorar o planejamento nacional do uso da terra e a contabilização de carbono. Esse conjunto de dados define as florestas primárias como "cobertura florestal tropical úmida natural madura que não foi completamente desmatada e regenerada na história recente". Pesquisadores classificaram imagens do programa Landsat em dados de florestas primárias, usando um algoritmo separado para cada região.',
  },
  citation: {
    label: 'Citação',
    value:
      'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Ongoing primary forest loss in Brazil, Democratic Republic of the Congo, and Indonesia. Environmental Research Letters, 13(7), p.074028. Accessed through Global Forest Watch on 31/01/2025. www.globalforestwatch.org.',
  },
};
